import { ObjectDisplay } from './ObjectDisplay'

interface Props {
  value: unknown
  maxLength?: number
  className?: string
}

/**
 * Smart component that displays values appropriately based on their type:
 * - Objects: Shows in ObjectDisplay component (structured table)
 * - Strings: Shows as-is (with optional truncation)
 * - Primitives: Converts to string
 * - Arrays: Shows JSON (could be enhanced to show array items individually)
 */
export function SmartValueDisplay({ value, maxLength = 500, className = '' }: Props) {
  // Handle objects (excluding arrays and null)
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return (
      <div className={className}>
        <ObjectDisplay data={value} />
      </div>
    )
  }

  // Handle strings
  if (typeof value === 'string') {
    const displayValue = value.length > maxLength ? value.slice(0, maxLength) + '...' : value
    return (
      <div className={`rounded-lg border border-gray-200 bg-gray-50 p-2 ${className}`}>
        <div className="whitespace-pre-wrap font-mono text-xs text-gray-900">{displayValue}</div>
      </div>
    )
  }

  // Handle arrays and other values - show as JSON
  const jsonString = JSON.stringify(value, null, 2)
  const displayValue =
    jsonString.length > maxLength ? jsonString.slice(0, maxLength) + '...' : jsonString

  return (
    <div className={`rounded-lg border border-gray-200 bg-gray-50 p-2 ${className}`}>
      <div className="whitespace-pre-wrap font-mono text-xs text-gray-900">{displayValue}</div>
    </div>
  )
}
